import classNames from 'classnames'
import { useCallback, useEffect, useState } from 'react'

import { Button } from 'core-components/library/button'
import { TPopupVertical } from 'core-components/library/popup'

import { Calendar } from './calendar/Calendar'
import { setHours } from './helpers/setHours'
import { Input } from './Input'
import { IDatePickerPopup } from './models/IDatePickerPopup'

import styles from './Popup.module.scss'

export const DatePickerPopup = (props: IDatePickerPopup) => {
  const [popupValue, setPopupValue] = useState<any>(props.value)
  const { mode } = props

  const onTodayButtonClick = useCallback(
    (today: Date) => {
      if (mode === 'single') {
        setPopupValue(today)
      } else if (mode === 'multiple') {
        setPopupValue([today])
      } else if (mode === 'range') {
        setPopupValue(setHours({ from: today, to: today }))
      }
      // props.close()
    },
    [mode]
  )

  const inputProps = {
    ...props,
    onTodayButtonClick,
    value: popupValue,
    onChange: (data: any) => {
      if (props.withTimeZone) {
        setPopupValue(data)
      } else {
        setPopupValue(setHours(data))
      }
    },
  }

  const applyHandler = () => {
    props.onChange(popupValue)
    props.close()
  }

  const cancelHandler = () => {
    props.close()
  }

  const rootClasses = classNames(
    styles.root,
    props.verticalDirection === TPopupVertical.Top
      ? styles['root--topDirection']
      : styles['root--bottomDirection']
  )

  useEffect(() => {
    setPopupValue((prev: any) => {
      if (typeof prev === 'object' && typeof props.value === 'object') {
        if (JSON.stringify(prev) !== JSON.stringify(props.value)) {
          return props.value
        }
        return prev
      }

      return props.value
    })
  }, [props.value])

  return (
    <div className={rootClasses}>
      <Input
        {...inputProps}
        classes={{ inputClasses: { root: styles.input } }}
        isPopupInput={true}
      />

      <Calendar {...inputProps} />

      <div className={styles.actions}>
        <Button
          className={styles.actions__item}
          icon={'kbase kbase-close-circle'}
          variant={'outlined'}
          onClick={cancelHandler}
        >
          Cancel
        </Button>
        <Button
          className={styles.actions__item}
          icon={'kbase kbase-save'}
          onClick={applyHandler}
          __testId={'apply_button'}
        >
          Apply
        </Button>
      </div>
    </div>
  )
}
